import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: 'url(https://public.readdy.ai/ai/img_res/0ab7615971570267035828b98c05905d.jpg)'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/70 to-black/50"></div>
      
      <div className="container mx-auto px-6 relative z-10 w-full">
        <div className="max-w-3xl">
          <div className="inline-block bg-amber-400/20 backdrop-blur-sm border border-amber-400/30 px-6 py-2 rounded-full mb-6">
            <p className="text-amber-300 text-sm font-medium flex items-center gap-2">
              <i className="ri-shield-check-line text-lg"></i>
              Más de 10 años de experiencia en gestión de cobranzas
            </p>
          </div>

          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Soluciones Profesionales de{' '}
            <span className="text-amber-400">Cobranza</span>
          </h1>
          
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Congarantías SAS ofrece servicios especializados en gestión de cartera y cobranza, 
            ayudando a empresas y personas a recuperar su estabilidad financiera con ética y profesionalismo.
          </p>

          <div className="flex flex-wrap gap-4">
            <a
              href="https://wa.me/573183365407?text=Hola,%20quiero%20consultar%20mi%20deuda"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-gray-700 text-white px-8 py-4 text-lg font-medium hover:bg-gray-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg hover:shadow-xl"
            >
              <i className="ri-question-line text-xl"></i>
              Consultar Deuda
            </a>
            
            <a
              href="/pagar-deuda"
              className="bg-amber-500 text-white px-8 py-4 text-lg font-medium hover:bg-amber-600 transition-all duration-200 whitespace-nowrap cursor-pointer flex items-center gap-2 shadow-lg hover:shadow-xl"
            >
              <i className="ri-bank-card-line text-xl"></i>
              Pagar Mi Deuda
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-4xl text-amber-400"></i>
      </div>
    </section>
  );
}
